import { Component, OnInit, ViewChild } from '@angular/core';
import { MDBModalService, ToastService } from 'ng-uikit-pro-standard';
import {
  CartSummary,
  EffectNoficationType,
  NotificationType,
} from 'src/app/shared-core/models/cart-data.model';
import { ElementRef, HostListener } from '@angular/core';
import { ModalContainerComponent, ModalDirective } from 'ng-uikit-pro-standard';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { ProcessingState, CheckoutService } from 'src/app/shared-core/services/checkout.service';
import { CartOrderOptions, CheckoutData, PaymentType } from 'src/app/shared-core/models/checkout-data.model';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Payments } from 'src/app/shared-core/models/checkout-data.model';
import { ComponentMessagingService } from 'src/app/shared-core/services/component-messaging.service';
import { MessageTopicsEnum } from 'src/app/shared-core/models/component-message.model';
import {
    CheckEnrollAndAuthorizeRequest,
    ConsumerOrderDetails,
    CreditCard,
    PayerAuthSetup,
    PayerAuthSetupResponse,
    PaymentAuthorizationRequest,
    PaymentAuthorizationResponse, toCreditCardForRequest,
    ValidatePayerAuth
} from "src/app/shared-core/models/payer-auth.model";
import { CheckoutType, PayerAuthService } from 'src/app/shared-core/services/payer-auth.service';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { AppConfigService } from 'src/app/shared-core/services/app-config.service';
import { finalize } from 'rxjs/operators';
import { ModalComponent } from 'src/app/cart/shared/modal/modal.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit {
  ProcessingState = ProcessingState;
  Number = Number;

  modalRef: MDBModalRef;
  cartSummary: CartSummary;
  promoCodeDisplay: number | string;
  promoCodeForm: FormGroup;
  isLease: boolean = false;
  isUser: boolean = false;
  isPurchaseCompleted: boolean = false;
  checkoutData: CheckoutData;
  checkoutForm: FormGroup;
  purchaseErrors: string[] = null;

  @ViewChild('authResultForm', { static: false })
  authResultForm: ElementRef<HTMLFormElement>;
  @ViewChild('stepUpModal') stepUpModal: ModalDirective;
  @ViewChild('frame', { static: true }) frame: ModalContainerComponent;
  @ViewChild('ddcForm', { static: false }) ddcForm: ElementRef<HTMLFormElement>;
  @ViewChild('stepUpForm', { static: false }) stepUpForm: ElementRef<HTMLFormElement>;
  stepUpMerchantData = window.location.href;

  payerAuthSetupResponse: PayerAuthSetupResponse;
  authorizationRequest: PaymentAuthorizationRequest;
  authorizationResponse: PaymentAuthorizationResponse;

  vistekUrl: string;
  cartOption: CartOrderOptions;
  creditCard: CreditCard;
  authResultUrl: string;

  get hasUnappliedCoupon(): boolean {
    if (!this.promoCodeForm) {
      return false;
    }

    return Boolean(this.promoCodeForm.get('promoCode').value);
  }

  ngOnInit(): void {
    this.service.checkingOutState$.subscribe(state => {
      if (state === ProcessingState.ChallengeReceived) {
        this.stepUpModal.show();
      } else if (this.stepUpModal?.isShown) {
        this.stepUpModal.hide();
      }
    });
    
    this.promoCodeForm = this.formBuilder.group({
      promoCode: ['', [Validators.required]],
    });
    this.checkoutForm = new FormGroup({
      specialinstructions: new FormControl(null),
      subscribeToNewsletter: new FormControl(null),
    });

    this.service.CheckoutDataSubject.subscribe((model) => {
      this.toaster.clear();
      this.isLease = model?.Payments?.PaymentType === PaymentType.Lease;
      this.checkoutData = model;
      this.cartSummary = model?.CartSummary ?? ({} as CartSummary);

      this.isUser = model?.IsUser;
      if (model?.CartSummary) {
        this.isPurchaseCompleted = 
            Boolean(!model.CartSummary.RequireTerms || model.CartSummary?.AcceptedTerms) &&
            Boolean(!model.CartSummary.RequireDropshipTerms || model.CartSummary?.AcceptedDropshipTerms);
      }

      if (!model?.Payments.PaymentValid) {
        this.isPurchaseCompleted = false;
      }

      let hasPaypalToken = !!model?.Payments?.PaypalPayment?.PaypalToken;
      if (model?.Payments.PaymentType === PaymentType.PayPal && hasPaypalToken) {
        this.isPurchaseCompleted = true;
      }

      const errorMessages = model?.CartOrder?.DisplayMessage;
      this.purchaseErrors = errorMessages?.filter((value, index, self) => self.indexOf(value) === index);
      this.service.showErrorPanel(this.purchaseErrors);

      this.promoCodeDisplay = this.getPromoCodeDisplay();
      this.displayPromotionNotifications(model);
      this.service.checkingOutState = ProcessingState.Ready;
    });

    this.service.PaypalPaymentSubject.subscribe((payment) => {
      if (!payment) return;
      if (!payment.PaymentValid) {
        this.isPurchaseCompleted = false;
      }
      let hasPaypalToken = !!payment?.PaypalPayment?.PaypalToken;
      if (payment.PaymentType === PaymentType.PayPal && hasPaypalToken) {
        this.isPurchaseCompleted = true;
      }
    });

    this.service.PaymentTypeSubject.subscribe((payment) => {
      if (!payment) {
        return;
      }

      this.isLease = payment === PaymentType.Lease;
      this.service.updatePaymentType(payment).subscribe(() => { });
    });

    this.messaging.onMessage().subscribe((msg) => {
      if (msg.topic === MessageTopicsEnum.PaymentInfoResponse) {
        if (msg instanceof Error) {
          this.handleHttpError(msg);
        }
        if ((msg.content as Payments)?.PaymentType) {
          this.completePurchase(msg.content as Payments);
        } else {
          this.service.checkingOutState = ProcessingState.Ready;
        }
      }
    });
  }

  constructor(
    public service: CheckoutService,
    private toaster: ToastService,
    private messaging: ComponentMessagingService,
    private payerAuthService: PayerAuthService,
    private appConfigService: AppConfigService,
    private formBuilder: FormBuilder,
    private _modalService: MDBModalService
  ) {
    this.vistekUrl = this.appConfigService.vistekUrl;
  }
  private displayPromotionNotifications(model: CheckoutData) {
    if (model.PromoNotifications) {
      model.PromoNotifications.forEach((el) => {
        switch (el.EffectType) {
          case EffectNoficationType.Removed:
            this.toaster.info(`Promotion "${el.RuleName}" is removed`);
            break;
          case EffectNoficationType.Rejected:
            this.toaster.error(el.Props.Body, `Coupon ${el.Coupon} is rejected.`, {
              enableHtml: true,
            });
            break;
          case EffectNoficationType.ShowNotification:
            switch (el.Props.NotificationType) {
              case NotificationType.Error:
                this.toaster.error(el.Props.Body, el.Props.Title);
                break;
              case NotificationType.Offer:
                this.toaster.success(el.Props.Body, el.Props.Title);
                break;
              default:
                this.toaster.info(el.Props.Body, el.Props.Title);
            }
        }
      });
      model.PromoNotifications = null;
    }
  }

  private getPromoCodeDisplay(): number {
    if (this.cartSummary.DisplayCoupon) {
      return this.cartSummary.Discount;
    }
  }

  savePaymentAndCompletePurchase() {
    if (this.hasUnappliedCoupon) {
      this.modalRef = this._modalService.show(ModalComponent, {
        data: {
          heading: 'Heads Up! You have an unapplied coupon!',
          content: 'You added a coupon but forgot to hit apply.<br><br>Please make sure to go back and hit apply, or remove the coupon if you don\'t want to use it anymore!'
        },
        class: 'modal-dialog-centered modal-lg'
      })
      return;
    }

    this.service.showErrorPanel(null);
    if (!this.validateAllSections()) {
      return;
    }
    
    this.service.checkingOutState = ProcessingState.PersistingPaymentDataBeforeAuthorization;
    
    this.messaging.sendMessage(MessageTopicsEnum.PaymentInfoRequest, null);
  }

  validateAllSections(): boolean {
    if (!this.service.CheckoutData.CartOrder.ShippingAddressCompleted || !this.service.isEmailCompleted()) {
      this.scrollTo('shippingAddressBookmark');
      this.service.showErrorPanel([
        "<strong>My Account Info</strong> section is not complete. Please complete it and click <strong>'Continue to Delivery Method'</strong>",
      ]);
      return false;
    }
    if (!this.service.CheckoutData.CartOrder.BillingAddressCompleted) {
      this.scrollTo('billingAddressBookmark');
      this.service.showErrorPanel([
        "<strong>Select Billing Address</strong> section is not complete. Please complete it and click <strong>'Continue to Payment'</strong>",
      ]);
      return false;
    }

    return true;
  }

  completePurchase(payment: Payments) {
    this.checkoutData.Payments = payment;
    let acceptSpecialOrderTerms = <HTMLInputElement>document.getElementById('acceptSpecialOrderTerms');
    let isAcceptSpecialOrderTermsChecked = acceptSpecialOrderTerms?.checked ?? false;

    let acceptDropshipTerms = <HTMLInputElement>document.getElementById('acceptDropshipTerms');
    let isAcceptDropshipTermsChecked = acceptDropshipTerms?.checked ?? false;
    
    if (this.cartSummary?.RequireTerms && !isAcceptSpecialOrderTermsChecked) {
      this.purchaseErrors = ['Please accept special order terms'];
      this.service.showErrorPanel([...this.purchaseErrors]);
      this.service.checkingOutState = ProcessingState.Ready;
      return;
    }

    if (this.cartSummary?.RequireDropshipTerms && !isAcceptDropshipTermsChecked) {
      this.purchaseErrors = ['Please accept dropship terms'];
      this.service.showErrorPanel([...this.purchaseErrors]);
      this.service.checkingOutState = ProcessingState.Ready;
      return;
    }
    
    this.cartOption = new CartOrderOptions();
    this.cartOption.AcceptedTerms = isAcceptSpecialOrderTermsChecked;
    this.cartOption.AcceptedDropshipTerms = isAcceptDropshipTermsChecked;
    this.cartOption.Auth = false;

    this.cartOption.CustomerComments = this.checkoutForm.value.specialinstructions;
    this.cartOption.Enews = !!this.checkoutForm.value.subscribeToNewsletter;

    this.service.checkingOutState = ProcessingState.ProcessingAuthorization;

    if (payment.PaymentType === PaymentType.CreditCard) {
      this.completeCreditCardPurchase(payment);
      return;
    }

    if (payment.PaymentType === PaymentType.SavedCreditCard) {
      this.completeSavedCreditCardPurchase(payment);
      return;
    }

    this.service
      .Process(this.cartOption)
      .pipe(
        finalize(() => {
          this.service.checkingOutState = ProcessingState.Ready;
        })
      )
      .subscribe((data) => {
        if (data.Success && data.ReturnUrl) {
          window.location.href = data.ReturnUrl;
          return;
        }
        const distinctErrors = data.Errors?.filter((value, index, self) => self.indexOf(value) === index);
        this.purchaseErrors = distinctErrors;
        let bottomMsg: string = null;
        // if the result is an error which requires a redirection to some other page, we'll do it automatically
        if (data.ReturnUrl) {
          setTimeout(() => {
            window.location.href = data.ReturnUrl;
          }, 20000);
          bottomMsg = 'The page will be reloaded shortly, you can try again right after.';
        }
        this.service.showErrorPanel([...this.purchaseErrors], bottomMsg);
        this.ScrollToError();
      });
  }

  completeSavedCreditCardPurchase(payment: Payments): void {
    this.creditCard = {
      accountNumber: "",
      cardCode: "",
      expirationMonth: "",
      expirationYear: "",
      nameOnAccount: "",
      tokenId: payment.CardPayment.TokenId
    };

    this.service.checkingOutState = ProcessingState.ProcessingAuthorization;

    (window as any).LogRocket?.track('setupPayerAuthCofStarts', {
      email: this.checkoutData.CartOrder.Email,
      billingName: `${this.checkoutData.CartOrder.Billing.FirstName} ${this.checkoutData.CartOrder.Billing.LastName}`,
      shippingName: `${this.checkoutData.CartOrder.Shipping.FirstName} ${this.checkoutData.CartOrder.Shipping.LastName}`,
      navSalesId: this.checkoutData.CartOrder.InvoiceNumber,
      navDocumentNo: null,
      cardholderName: payment.CardPayment.CardHolder,
    });
    this.payerAuthService.setupPayerAuthCof(CheckoutType.WebSale).subscribe(
      (result) => {
        this.payerAuthSetupResponse = result;
        setTimeout(() => {
          this.ddcForm.nativeElement.submit();
        });
      },
      (error: HttpErrorResponse) => {
        this.handleHttpErrorForCCPayment(error);
      }
    );
  }

  completeCreditCardPurchase(payment: Payments): void {
    this.creditCard = {
      accountNumber: payment.CardPayment.Card,
      cardCode: payment.CardPayment.CSC,
      expirationMonth: payment.CardPayment.ExpiryMonth,
      expirationYear: payment.CardPayment.ExpiryYear,
      nameOnAccount: payment.CardPayment.CardHolder,
      tokenId: payment.CardPayment.TokenId
    };

    const model: PayerAuthSetup = {
      cardNumberHidden: btoa(this.creditCard.accountNumber),
      cardholderName: this.creditCard.nameOnAccount,
      expirationMonth: this.creditCard.expirationMonth,
      expirationYear: this.creditCard.expirationYear,
      invoiceNumber: this.checkoutData.CartOrder.InvoiceNumber,
      orderId: this.checkoutData.CartOrder.OrderID,
      orderDetails: this.getOrderDetails(),
    };
    this.service.checkingOutState = ProcessingState.ProcessingAuthorization;
    (window as any).LogRocket?.track('setupPayerAuthStarts', {
      email: this.checkoutData.CartOrder.Email,
      billingName: `${this.checkoutData.CartOrder.Billing.FirstName} ${this.checkoutData.CartOrder.Billing.LastName}`,
      shippingName: `${this.checkoutData.CartOrder.Shipping.FirstName} ${this.checkoutData.CartOrder.Shipping.LastName}`,
      navSalesId: this.checkoutData.CartOrder.InvoiceNumber,
      navDocumentNo: null,
      cardholderName: payment.CardPayment.CardHolder,
    });
    this.payerAuthService.setupPayerAuth(CheckoutType.WebSale, model).subscribe(
      (result) => {
        this.payerAuthSetupResponse = result;
        setTimeout(() => {
          this.ddcForm.nativeElement.submit();
        });
      },
      (error: HttpErrorResponse) => {
        this.handleHttpErrorForCCPayment(error);
      }
    );
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: { origin: string; data: string; }): void {
    if (
      event.origin === 'https://centinelapistag.cardinalcommerce.com' ||
      event.origin === 'https://centinelapi.cardinalcommerce.com'
    ) {
      const data = JSON.parse(event.data);

      if (data === undefined || !data.Status) {
        return;
      }
      this.service.checkingOutState = ProcessingState.ProcessingAuthorization;
      this.authorizationRequest = this.getAuthorizationRequest();
      this.payerAuthService.authorizePayment(CheckoutType.WebSale, this.authorizationRequest).subscribe(
        (result) => {
          this.authorizationResponse = result;
          this.processAuthorizationResponse();
        },
        (error) => {
          this.handleHttpErrorForCCPayment(error);
        }
      );
    }
    if (event.origin === this.vistekUrl && this.authorizationRequest) {
      let validateResp: ValidatePayerAuth;
      try {
        validateResp = JSON.parse(event.data);
        if (!validateResp.TransactionId) {
          return;
        }
      } catch (error) {
        // this is needed because device fingerprint also posts the same event.origin, but we don't care
        return;
      }
      this.service.checkingOutState = ProcessingState.ProcessingAuthorization;
      this.payerAuthService
        .validatePayerAuth(CheckoutType.WebSale, validateResp.TransactionId, this.authorizationRequest)
        .subscribe(
          (result) => {
            this.authorizationResponse = result;
            this.processAuthorizationResponse();
          },
          (error) => {
            this.handleHttpErrorForCCPayment(error);
          }
        );
    }
  }

  getOrderDetails(): ConsumerOrderDetails {
    return {
      SalesOrderId: this.checkoutData.CartID, // this comes from Nav, doesn't exist yet at this point
      OrderNumber: this.checkoutData.CartOrder.OrderID,
      Amount: this.checkoutData.Payments.BalanceDue, // will be set on the server as currently the amount due (total - gift_cards) is not readily available on the client
      CustomerComments: this.cartOption.CustomerComments,
      AcceptedTerms: this.cartOption.AcceptedTerms,
      AcceptedDropshipTerms: this.cartOption.AcceptedDropshipTerms,
      Enews: this.cartOption.Enews,
    };
  }

  /** creates a request for CyberSource payment */
  getAuthorizationRequest(): CheckEnrollAndAuthorizeRequest {
    const subForTokenElement = document.getElementById('savePaymentDetailsForLater');
    const subForDefaultTokenElement = document.getElementById('setDefaultPaymentMethod');

    const authorizationRequest: CheckEnrollAndAuthorizeRequest = {
      ConsumerAuthReferenceId: this.payerAuthSetupResponse.referenceId,
      TransactionMode: 'Web',
      Account: toCreditCardForRequest(this.creditCard),
      OrderDetails: this.getOrderDetails(),
      BrowserScreenHeight: window.screen.height.toString(),
      BrowserScreenWidth: window.screen.width.toString(),
      ShouldCreateNetworkToken: (subForTokenElement as HTMLInputElement)?.checked,
      ShouldSetDefaultNetworkToken: (subForDefaultTokenElement as HTMLInputElement)?.checked,
      InstrumentIdentifierId: this.creditCard.tokenId
    };
    
    return authorizationRequest;
  }

  /** part of CyberSource payment processing */
  processAuthorizationResponse() {
    if (this.authorizationResponse.Approved) {
      this.service.checkingOutState = ProcessingState.AuthorizationReceived;
      this.authResultUrl = `cart/checkout/complete`;
      setTimeout(() => {
        this.authResultForm.nativeElement.submit();
      });
    } else {
      if (this.authorizationResponse.Challenge) {
        this.service.checkingOutState = ProcessingState.ChallengeReceived;
        setTimeout(() => {
          this.stepUpForm.nativeElement.submit();
        });
      } else {
        this.service.checkingOutState = ProcessingState.AuthorizationReceived;
        this.authResultUrl = `cart/checkout/declined`;
        setTimeout(() => {
          this.authResultForm.nativeElement.submit();
        });
      }
    }
  }

  handleHttpError(error: Error): void {
    let message = 'Your payment cannot be processed due to an error on our side. Please contact Customer Support...';
    this.service.checkingOutState = ProcessingState.Ready;
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) {
        message =
          'We have not received a response from the server in a timely manner, this may have been caused by a network delay. Please try again.';
      }
    }
    setTimeout(() => {
      this.toaster.error(message);
    });
  }

  handleHttpErrorForCCPayment(error: Error): void {
    let message = 'Your payment cannot be processed due to an error on our side. Please contact Customer Support...';
    this.service.checkingOutState = ProcessingState.Ready;
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) {
        message =
          'We have not received a response from the server in a timely manner, this may have been caused by a network delay. Please try again.';
      }
      if (error.status == HttpStatusCode.Conflict) {
        // reload for now, but maybe just refresh page data?
        window.location.reload();
        return;
      }
      if (error.status === HttpStatusCode.NotFound) {
        if (error.error === 'OrderNotFound') {
          message = 'Your order is not found or already processed';
        }
        if (error.error === 'CheckoutIsNotFound') {
          // reload, because if checkout data is not found, we cannot proceed
          window.location.reload();
          return;
        }
      }
      if (error.status == HttpStatusCode.UnprocessableEntity) {
        this.purchaseErrors = (Object.values(error.error) as string[][])
          .reduce((prev, curr, idx, arr) => curr)
          .filter((value, index, self) => self.indexOf(value) === index);
        this.service.showErrorPanel([...this.purchaseErrors]);
        this.ScrollToError();
        return;
      }
    }
    setTimeout(() => {
      this.toaster.error(message);
    });
  }

  IsErrorsListContains(passedinstring: string): boolean {
    if (!this.purchaseErrors) return false;
    passedinstring = passedinstring.toLowerCase();
    let filteredArray = this.purchaseErrors.filter((str) => str.toLowerCase().includes(passedinstring));
    return filteredArray && filteredArray.length > 0;
  }

  ScrollToError() {
    if (!this.purchaseErrors) return;
    //strp 01 : check if has issue with 'Shipping Address' or email aaddress
    // if yes then scroll to Shipping Address

    if (this.IsErrorsListContains('Account Info')) {
      this.scrollTo('shippingAddressBookmark');
      return;
    }
    if (this.IsErrorsListContains('Billing Address')) {
      this.scrollTo('billingAddressBookmark');
      return;
    }
    if (this.IsErrorsListContains('Email Address')) {
      this.scrollTo('shippingAddressBookmark');
      return;
    }
  }

  scrollTo(id: string) {
    let el = document.getElementById(id);
    el.scrollIntoView();
  }

  calculateCoupon(): void {
    if (!this.promoCodeForm.valid) {
      return;
    }

    this.service.updatePromoCode(this.promoCodeForm.value.promoCode).subscribe((data) => {
      this.promoCodeForm.patchValue(
        { promoCode: '' },
        {
          emitEvent: false,
        }
      );
    });
  }

  onStepUpClosed() {
    if (this.service.checkingOutState === ProcessingState.ChallengeReceived) {
      this.service.checkingOutState = ProcessingState.Ready;
    }
  }
}
